import React, { PropsWithChildren, useState } from "react";
import classNames from "classnames";
import ArrowTopIcon from "../../images/arrow-top.svg";

type AccordionProps = {
  title: string;
  icon?: React.ReactNode;
  isOpen?: boolean;
  className?: string;
  setIsOpen?: (isOpen: boolean) => void;
};

export const Accordion = ({
  title,
  icon,
  children,
  isOpen: controlledIsOpen,
  setIsOpen: setControlledIsOpen,
  className,
}: PropsWithChildren<AccordionProps>) => {
  const [isOpen, setIsOpen] = useState(false);
  const actualIsOpen =
    controlledIsOpen !== undefined ? controlledIsOpen : isOpen;
  const toggleOpen = () => {
    if (setControlledIsOpen) {
      setControlledIsOpen(!controlledIsOpen);
    } else {
      setIsOpen(!isOpen);
    }
  };

  return (
    <div
      className={classNames(
        "w-full border border-grey-lighter rounded-[16px] p-4",
        className
      )}
    >
      <div
        className={classNames(
          "p-4 cursor-pointer flex justify-between items-center",
          { "border-b border-grey-lighter": actualIsOpen }
        )}
        onClick={toggleOpen}
      >
        <div className="flex items-center gap-8">
          <div>{icon}</div>
          <div className="text-lg md:text-md font-medium">{title}</div>
        </div>
        <span
          className={classNames("text-gray-500", {
            "rotate-180": !actualIsOpen,
          })}
        >
          <ArrowTopIcon />
        </span>
      </div>

      {actualIsOpen && <div className="md:pt-[40px] pt-[20px]">{children}</div>}
    </div>
  );
};
